import { useLocation, useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import AppContext from "../Context/Context";
import { useGlobalState } from "../Context/GlobalStateContext";
import { hasAccess } from "./Permissions";
export default function RequireAuth({ children }: any) {
  const location = useLocation();
  let completeURL = location.pathname + location.search;
  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(true);
  const [OkToGo, setOkToGo] = useState(false);
  const globalState = useGlobalState();
  const navigate = useNavigate();

  useEffect(() => {
    //   const CheckIsUserLoggedIn = async () => {
    //     const isLoggedIn = await AppContext.IsUserLoggedIn();
    //     if (isLoggedIn === true) {
    //       var token = AppContext.GetCookie("Token");
    //       if (token && token !== "") {
    //         SetUserInfo(token);
    //       }
    //       // window.location.href = "/home";
    //       return true;
    //     } else {
    //       globalState.setLogInUserName("");
    //       globalState.setLogInUserImage("");
    //       globalState.setLogInUserRole("");
    //       AppContext.LogInUserName = "";
    //       return false;
    //     }
    //   };

    // const SetUserInfo = (token: any) => {
    //   if (token && token !== "") var UserInfo: any = jwt_decode(token);
    //   if (UserInfo && UserInfo !== "") {
    //     globalState.setLogInUserName(UserInfo.username);
    //     globalState.setLogInUserImage(UserInfo.userimage);
    //     globalState.setLogInUserRole(UserInfo.role);
    //     AppContext.LogInUserName = UserInfo.username;
    //   }
    // };

    const CheckIsUserLoggedIn = async () => {
      const Local_Token = process.env.REACT_APP_Local_Token;
      if (
        Local_Token &&
        Local_Token !== "" &&
        !AppContext.IsJwtExpired(Local_Token)
      ) {
        SetUserInfo(1, Local_Token);
        return true;
      } else {
        let ReturnData = await AppContext.CheckLoginValidity();
        if (ReturnData.role === "") {
          return false;
        } else {
          SetUserInfo(2, ReturnData);
          return true;
        }
      }
    };

    const SetUserInfo = (type: number, data: any) => {
      if (type === 1) {
        if (data && data !== "") var UserInfo: any = jwt_decode(data);
        if (UserInfo && UserInfo !== "") {
          globalState.setLogInUserName(UserInfo.username);
          globalState.setLogInUserImage(UserInfo.userimage);
          globalState.setLogInUserRole(UserInfo.role);
          AppContext.LogInUserRole = UserInfo.role;
        }
      } else {
        globalState.setLogInUserName(data.username);
        globalState.setLogInUserImage(data.userimage);
        globalState.setLogInUserRole(data.role);
        AppContext.LogInUserRole = data.role;
      }
    };

    (async () => {
      if ((await CheckIsUserLoggedIn()) === true) {
        let havePermission =
          await AppContext.CheckAccessAndSettings(completeURL);
        if (havePermission) {
          globalState.setManageObject(AppContext.ManageObj);
          setIsUserLoggedIn(true);
        } else {
          setIsUserLoggedIn(false);
          window.location.href = "https://www.finestvan.co.uk/";
        }
        let ReturnData = await AppContext.GetLoggedinUserRoleDetails();
        let RoleName = "";
        let isUserHasAccess = false;
        if (ReturnData && ReturnData[0] && ReturnData[0].length > 0) {
          AppContext.MNVMoverID = ReturnData[0][0].MNVMoverID;
          AppContext.IsContractor = ReturnData[0][0].IsContractor;

          globalState.setMNVMoverID(ReturnData[0][0].MNVMoverID);
          globalState.setIsContractor(ReturnData[0][0].IsContractor);

          globalState.setIsPorter(
            ReturnData[0][0].MNVMoverID > 0 ? true : false,
          );

          if (ReturnData[0][0].MNVMoverID > 0) {
            globalState.setIsDriverLoggedIn(
              ReturnData[0][0].IsDriver == 1 ? true : false,
            );
            globalState.setIsHelperLoggedIn(
              ReturnData[0][0].IsDriver == 1 ? false : true,
            );
          }
          globalState.setUserMobile(ReturnData[0][0].Mobile);
          globalState.setUserEmail(ReturnData[0][0].Email);
          globalState.setLoggedInUserID(ReturnData[0][0].SiteUserID);

          if (ReturnData && ReturnData[1] && ReturnData[1].length > 0) {
            globalState.setRolesList(ReturnData[1][0]);
          }

          let IsAdmin = false;
          let IsSemiAdmin = false;
          let IsBlogAdmin = false;

          RoleName = ReturnData[0][0]["RoleName"];
          if (RoleName == "Admin") IsAdmin = true;
          if (RoleName == "Semi-Admin") IsSemiAdmin = true;
          else if (RoleName == "Blog Admin") IsBlogAdmin = true;

          AppContext.IsAdmin = IsAdmin;
          AppContext.IsSemiAdmin = IsSemiAdmin;
          AppContext.IsBlogAdmin = IsBlogAdmin;

          if (
            ReturnData[0][0].MNVMoverID > 0 &&
            ReturnData[0][0].IsContractor == false
          ) {
            let TimeEntryIsPendingData =
              await AppContext.MoverCheckIfAnyTimeEntryIsPending();
            globalState.setShowTimeEntryIsPendingModalData(
              TimeEntryIsPendingData,
            );
            if (TimeEntryIsPendingData && TimeEntryIsPendingData.length > 0) {
              globalState.setShowTimeEntryIsPendingModal(true);
              navigate("/employeetimelog");
            } else {
              globalState.setShowTimeEntryIsPendingModal(false);
            }
          }

          if (
            IsAdmin ||
            IsSemiAdmin ||
            IsBlogAdmin ||
            ReturnData[0][0].MNVMoverID > 0
          ) {
            if (completeURL == "" || completeURL == "/") {
              if (AppContext.MNVMoverID > 0) {
                window.location.href = "/driverdashboard";
              } else if (IsBlogAdmin == true) {
                window.location.href = "/blogarticle";
              } else if (IsSemiAdmin == true) {
                window.location.href = "/allquotes";
              } else if (IsAdmin == true) {
                window.location.href = "/allquotes";
              } else {
                window.location.href = "/notaccess";
              }
            } else {
              let allowedUsers = [RoleName];
              if (ReturnData[0][0].IsContractor == true) {
                allowedUsers.push("Contractor");
              }
              isUserHasAccess = hasAccess(completeURL, allowedUsers);
              if (isUserHasAccess == false) {
                window.location.href = "/notaccess";
              }
            }
            setIsUserLoggedIn(true);
          } else {
            window.location.href = "/notaccess";
          }
        } else {
          window.location.href = "/notaccess";
        }
      } else {
        setIsUserLoggedIn(false);
      }
      setOkToGo(true);
    })();

    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  let ReturnData = "" as any;
  if (IsUserLoggedIn === true && OkToGo) {
    ReturnData = children;
  } else if (IsUserLoggedIn === false && OkToGo) {
    window.location.href = "/login";
  }
  return ReturnData;
}
